import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Utils from "../Utils";

const NotificationBell = ({ NotificationListComponent }) => {
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const bellRef = useRef(null);

  useEffect(() => {
    axios
      .get(Utils.apiUrl("notifications?mode=count"), Utils.apiHeaders())
      .then((res) => setCount(res.data.total || 0))
      .catch(() => setCount(0));
  }, []);

  useEffect(() => {
    const handleClick = (event) => {
      if (bellRef.current && !bellRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  // Pass setCount as a prop to NotificationListComponent
  const NotificationList = NotificationListComponent;

  return (
    <div className="relative" ref={bellRef}>
      <button
        className="relative flex items-center text-gray-600 hover:text-blue-500 focus:outline-none"
        onClick={() => setOpen((o) => !o)}
        title="Notifications"
      >
        <i className="fas fa-bell text-xl"></i>
        {count > 0 && (
          <span className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full border border-gray-400 bg-red-500 text-xs text-white shadow-md">
            {count > 99 ? "99+" : count}
          </span>
        )}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-w-xs rounded-lg border bg-white shadow-lg z-50">
          <NotificationList
            onClose={() => setOpen(false)}
            onCountChange={setCount}
          />
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
